import {Route} from '@angular/router';
import {LoginUserComponent} from '@auth/login-user/login-user.component';
import {RegisterUserComponent} from '@auth/register-user/register-user.component';
import {ValidateUserEmailComponent} from '@auth/validate-user-email/validate-user-email.component';
import {ResetUserPasswordComponent} from '@auth/reset-user-password/reset-user-password.component';
import {HostResolver} from '@domain/host/host.resolver';
import {ValidateHostEmailComponent} from '@auth/host/validate-host-email/validate-host-email.component';
import {AuthGuard} from '@auth/auth.guard';
import {UnvalidatedUserGuard} from '@auth/unvalidated-user.guard';
import {ValidateJoinHostComponent} from '@auth/member/validate-join-host/validate-join-host.component';
import {MemberResolver} from '@domain/member/member.resolver';

export const AUTH_ROUTES: Route[] = [
  { path: 'register', component: RegisterUserComponent, canActivate: [AuthGuard]},
  { path: 'login', component: LoginUserComponent, canActivate: [AuthGuard]},
  { path: 'validate', component: ValidateUserEmailComponent, canActivate: [UnvalidatedUserGuard]},
  { path: 'validate-email', component: ValidateUserEmailComponent, canActivate: [UnvalidatedUserGuard]},
  { path: 'reset', component: ResetUserPasswordComponent, canActivate: [AuthGuard] },
  { path: 'reset-password', component: ResetUserPasswordComponent, canActivate: [AuthGuard] },
  {
    path: 'host/:hostId/validate',
    component: ValidateHostEmailComponent,
    resolve: {
      host: HostResolver.get
    }
  },
  {
    path: 'host/:hostId/validate-email',
    component: ValidateHostEmailComponent,
    resolve: {
      host: HostResolver.get
    }
  },
  {
    path: 'member/:memberId/join',
    component: ValidateJoinHostComponent,
    resolve: {
      host: MemberResolver.getHostPreview
    }
  },
];
